import React, { Component } from 'react';
import './style.css';

class ViewInvites extends Component {
  constructor(props){
    super(props)
    this.state={
    };

    this.getStatus = this.getStatus.bind(this);
  }

  backInvites(){
    this.props.backInvites();
  }

  getStatus(completionStatus){
    let status = "";
    if (completionStatus == 0){
      status = 'Not Attempted';
    }else if(completionStatus == 1){
      status = 'Completed';
    }else if(completionStatus == 2){
      status = 'Quota Fail';
    }else if(completionStatus == 3){
      status = 'Fail';
    }
    return status;
  }
 

  render(){
  
    let membersDataList = "";
    if(this.props.invitesDataResponse){
    if(this.props.invitesDataResponse && this.props.invitesDataResponse.length){
        let members = this.props.invitesDataResponse;
        membersDataList = Object.keys(members).map((item, index) => {
        let membersItem = members[item];
        let status = this.getStatus(membersItem.completionStatus);
        return <tr key={index} >
            <td>{membersItem.username}</td>
            <td>{membersItem.emailid}</td>
            <td>{status}</td>
          </tr>
        });
    }
  }else{
    membersDataList =
      <div>
      Not found invites Members 
      </div>
  }

  return (<div className = "userlist">
  <div className = "userlistbackground">
        <div className = "usertable"><h1>Invities Member's List</h1></div>
        <div className = "setbackbutton">
            <br/><button className = "editstudybackbtn" style={{marginLeft:"2%"}}  onClick={this.backInvites.bind(this)}>Back</button>
            </div>
        <div className = "autoscroll">
        <table className = "customerTable">
          <thead>
            <tr>
              
              <th>User name</th>
              <th>Email ID </th>
              <th>Completion Status </th>
              
            </tr>
          </thead>
            <tbody>
              {membersDataList}
            </tbody>
        </table>
        </div>
        </div>
        </div>
        
    );
  }
}
export default ViewInvites;



// WEBPACK FOOTER //
// ./src/components/Invites/index.js